import { TRADING_FIAT } from "@tradingApp/components/Trading/constants";
import {
  isBigInstance,
  toBig,
} from "@tradingApp/components/Trading/helpers/big";
import { percentageFormat } from "@tradingApp/components/Trading/helpers/percentage";
import { priceFormat } from "@tradingApp/helpers/price";
import type { TradingPerpAsset } from "@tradingApp/Providers/TradingProvider/types";

interface ReturnType {
  percentFormatted: string;
  percentRaw: string | null;
  priceRaw: string;
  priceFormatted: string | null;
}

/**
 * @example
 * const { percentFormatted, priceFormatted } = tradingAssetChange24h(assetData);
 */
export function tradingAssetChange24h(
  assetData: TradingPerpAsset | null | undefined,
): ReturnType {
  const markPrice = assetData ? toBig(assetData.markPx || 0) : null;
  const prevDayPxParsed = assetData ? toBig(assetData.prevDayPx) : null;

  const price =
    isBigInstance(markPrice) && isBigInstance(prevDayPxParsed)
      ? markPrice.minus(prevDayPxParsed)
      : null;

  const percent =
    isBigInstance(price) && isBigInstance(prevDayPxParsed)
      ? price.div(prevDayPxParsed).mul(100)
      : null;

  if (!isBigInstance(percent) || !isBigInstance(price)) {
    return {
      percentFormatted: percentageFormat({ percentage: null }),
      percentRaw: null,
      priceRaw: priceFormat({
        price: undefined,
        currency: TRADING_FIAT,
      }),
      priceFormatted: null,
    };
  }

  const percentRaw = percent.toString();
  const percentFormatted = percentageFormat({ percentage: percentRaw });
  const priceRaw = price.toString();

  const priceFormatted = priceFormat({
    price: priceRaw,
    currency: TRADING_FIAT,
  });

  return {
    percentFormatted,
    percentRaw,
    priceRaw,
    priceFormatted,
  };
}
